export default [{
  path: '/painel-oportunidades',
  name: 'painel-oportunidades',
  component: () => import('@/app-modulo/comercial/oportunidades/PainelOportunidades.vue'),
  meta: {
    resource: 'paineloportunidades',
    action: 'read',
    navActiveLink: 'painel-oportunidades',
    pageTitle: 'Jornada do Cliente',
    useButtonFunil: true,
  },
  children: [
    {
      path: '/painel-oportunidades/oportunidade/:oportunidadeId',
      component: () => import('@/app-modulo/comercial/oportunidades/shared/components/modal-detalhes-oportunidade/ModalDetalhesOportunidade.vue'),
      name: 'detalhes-oportunidade',
    },
  ],
}]
